module.exports = __webpack_public_path__ + "static/media/illustration.a51ee464.svg";